var _style, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 102 102",
    style: {
      enableBackground: "new 0 0 102 102"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000142171068960992162700000013988524443198668955_);}\n\t.st1{fill:none;stroke:#363636;stroke-width:2;stroke-miterlimit:10;}\n\t.st2{clip-path:url(#SVGID_00000110466630421689512620000003577457817368467843_);}\n\t.st3{fill:none;stroke:#323243;stroke-width:2;stroke-linejoin:round;}\n\t.st4{fill:none;stroke:#323243;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_00000105388601712673803340000002578747511650994343_",
    x: 3.5,
    y: 3.4,
    width: 95,
    height: 95
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000139995008255505026170000001030835335874873494_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000105388601712673803340000002578747511650994343_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000139995008255505026170000001030835335874873494_)"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 50,
    cy: 49.9,
    r: 33.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 50,
    cy: 49.9,
    r: 46.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,16.3V3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M50,96V83.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.7,26.1l8.9-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.4,82.5l8.9-8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M83.5,49.9h12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3.9,49.9h12.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.7,73.6l8.9,8.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.4,17.3l8.9,8.9"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCoin);
export default __webpack_public_path__ + "static/media/empty-coin.fe4d7f0ebda43e8db6aec16058ea73dd.svg";
export { ForwardRef as ReactComponent };